import { render, staticRenderFns } from "./PartPriceOverview.vue?vue&type=template&id=90f17780"
import script from "./PartPriceOverview.vue?vue&type=script&lang=js"
export * from "./PartPriceOverview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports